const byteToHex = (byte) => byte.toString(16).padStart(2, '0');

const createUuidFromRandomValues = (bytes) => {
  const copy = new Uint8Array(bytes);
  copy[6] = (copy[6] & 0x0f) | 0x40;
  copy[8] = (copy[8] & 0x3f) | 0x80;
  const hex = Array.from(copy, byteToHex).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
};

export const createRequestId = () => {
  const maybeCrypto =
    typeof window !== 'undefined' && window.crypto ? window.crypto : null;
  if (typeof maybeCrypto?.randomUUID === 'function') {
    return maybeCrypto.randomUUID();
  }
  if (typeof maybeCrypto?.getRandomValues === 'function') {
    const bytes = new Uint8Array(16);
    maybeCrypto.getRandomValues(bytes);
    return createUuidFromRandomValues(bytes);
  }

  const fallback = `${Date.now()}-${Math.random()}-${Math.random()}`;
  const encoded =
    typeof window !== 'undefined' && typeof window.btoa === 'function'
      ? window.btoa(fallback)
      : fallback.replace(/\W+/g, '');
  const normalized = `${encoded}${encoded}`.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
  return `${normalized.slice(0, 8)}-${normalized.slice(8, 12)}-4${normalized.slice(13, 16)}-a${normalized.slice(17, 20)}-${normalized.slice(20, 32)}`;
};
